
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
// eslint-disable-next-line no-undef
const SimpleBar = require("simplebar/dist/simplebar.min");

require("simplebar/dist/simplebar.min.css");

@Component
export default class Scrollbar extends Vue {
  @Prop({ default: null, type: Number }) readonly maxHeight!: number | null;
  @Prop({ default: false }) readonly hideHorizontal!: boolean;
  @Prop({ default: true }) readonly autoHide!: boolean;
  @Prop({ default: false }) readonly hideVertical!: boolean;
  @Prop({ default: false }) readonly red!: boolean;

  bar: any = null;

  mounted() {
    this.bar = new SimpleBar(this.$refs.simpleBar as HTMLDivElement);
  }

  get classes() {
    return {
      "hide-horizontal": this.hideHorizontal,
      "hide-vertical": this.hideVertical,
      red: this.red
    };
  }
}
